<div class="main-container lg-view" *ngIf="!isLoading">
	<h3>Add Note</h3>

	<div class="main-form">
		<form [formGroup]="formModel">
			<fieldset>
				<legend>{{ job.jobName }}</legend>

				<mat-form-field>
					<mat-label>Note</mat-label>
					<textarea matInput formControlName="description" rows="9"></textarea>
				</mat-form-field>

				<div class="checkbox-group-container" *ngIf="pageType === PageType.Customer">
					<mat-checkbox formControlName="isFollowUp">Add to Calendar</mat-checkbox>
				</div>

				<mat-form-field *ngIf="isFollowUp && pageType === PageType.Customer" class="calendar">
					<mat-label>Pick Date</mat-label>
					<input matInput [matDatepicker]="picker" formControlName="dueDate">
					<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>
				</mat-form-field>
			</fieldset>
		</form>
	</div>
</div>

<div class="actions-container  md-view" *ngIf="!isLoading">
	<ng-container *ngIf="isActionAvailable">
		<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'../'"></action-button>
		<action-button [icon]=" ButtonIcons.Submit" [name]="'Submit'" [clickAction]="submitComment.bind(self)"
			[disabled]="formModel.invalid"></action-button>
		<action-button [icon]=" ButtonIcons.People" [name]="'Contacts'" [subpage]="'contacts'"
			*ngIf="BitwiseHelper.and(pageType, PageType.AssigneeOrVendor)"></action-button>
	</ng-container>

	<div class="actions-placeholder-message" *ngIf="pageType === PageType.Customer && (customerPreferences.preferences.isJobAutoSkipped || customerPreferences.preferences.isNotificationDisabled)">
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
		<span
			*ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
			{{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.BothDisabled }}</span>
	</div>

	<div class="actions-placeholder-message" *ngIf="BitwiseHelper.and(pageType, PageType.AssigneeOrVendor) && customerPreferences.preferences.isJobAutoSkipped">
		<span *ngIf="customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
	</div>
</div>